module.exports = __webpack_public_path__ + "media/layer2_720p_1.a309e73d.webm";